import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { HasAnyPrivilegeDirective } from '../../core/directives/has-any-privilege.directive';
import { CurrencyInputDirective } from '../../core/directives/currency-input.directive';
import { AddEditCategoriesComponent } from './add-edit-categories/add-edit-categories.component';
import { AddEditTagsComponent } from './add-edit-tags/add-edit-tags.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { InteractiveMapComponent } from './interactive-map/interactive-map.component';
import { LucideAngularModule } from 'lucide-angular';
import { ExportContentComponent } from './export-content/export-content.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@NgModule({
  declarations: [
    HasAnyPrivilegeDirective,
    CurrencyInputDirective,
    AddEditCategoriesComponent,
    AddEditTagsComponent,
    InteractiveMapComponent,
    ExportContentComponent,
  ],
  exports: [
    HasAnyPrivilegeDirective,
    CurrencyInputDirective,
    InteractiveMapComponent,
    ExportContentComponent,
  ], // 👈 makes it available to other modules
  imports: [
    CommonModule,
    TranslocoModule,
    NzButtonModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzWaveModule,
    ReactiveFormsModule,
    FormsModule,
    NzModalModule,
    LucideAngularModule,
    NzSpinModule,
    NzRadioModule,
    NzCheckboxModule,
  ],
})
export class SharedModule {}